import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Zap } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function AnomalyDetectionWidget({ anomalyHistory = [] }) {
  const navigate = useNavigate();
  if (anomalyHistory.length === 0) return null;
  const a = anomalyHistory[0];
  const tone = a.critical > 0 ? 'border-error/30 bg-error/10' : a.warning > 0 ? 'border-warning/30 bg-warning/10' : 'border-success/30 bg-success/10';
  const iconTone = a.critical > 0 ? 'text-error' : a.warning > 0 ? 'text-warning' : 'text-success';

  return (
    <Card className={`border ${tone}`} data-testid="anomaly-dashboard-widget">
      <CardContent className="p-4">
        <div className="flex items-center justify-between flex-wrap gap-2">
          <div className="flex items-center gap-2">
            <Zap size={16} className={iconTone} />
            <span className="text-sm font-semibold">Anomaly Detection</span>
            <span className="text-[10px] text-muted-foreground">Last scan: {a.scanned_at ? new Date(a.scanned_at).toLocaleDateString() : 'N/A'}</span>
          </div>
          <div className="flex items-center gap-2">
            {a.critical > 0 && <Badge className="bg-error/20 text-error text-[10px] border-0">{a.critical} Critical</Badge>}
            {a.warning > 0 && <Badge className="bg-warning/20 text-warning text-[10px] border-0">{a.warning} Warning</Badge>}
            {a.total_anomalies === 0 && <Badge className="bg-success/20 text-success text-[10px] border-0">All Clear</Badge>}
            <Button size="sm" variant="outline" className="h-6 text-[10px] px-2" onClick={() => navigate('/anomaly-detection')} data-testid="view-anomalies-btn">
              View Details
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
